import { isReadOnlySelector } from 'modules/MedComms/selectors';
import { createStructuredSelector } from 'reselect';
import { isResizingRow } from 'containers/App/selectors';
import { activeLayer } from 'containers/Project/selectors';

export const rowSelector = createStructuredSelector({
  isResizingRow,
  isReadOnly: isReadOnlySelector,
  activeLayer,
});
